import React from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { Book, Fuel, GalleryHorizontal, Calculator, Phone } from 'lucide-react';
import SectionBackButton from '../components/SectionBackButton';
import ServiceBookSection from './ServiceBookSection';
import FuelLogSection from './FuelLogSection';
import CarGallery from './CarGallery';
import TripCostCalculator from './TripCostCalculator';
import CarContactsSection from './CarContactsSection';

const CarSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route
        path="service-book"
        element={
          <>
            <SectionBackButton to="/car" label="Back to Car" />
            <ServiceBookSection />
          </>
        }
      />
      <Route
        path="fuel"
        element={
          <>
            <SectionBackButton to="/car" label="Back to Car" />
            <FuelLogSection />
          </>
        }
      />
      <Route
        path="gallery"
        element={
          <>
            <SectionBackButton to="/car" label="Back to Car" />
            <CarGallery />
          </>
        }
      />
      <Route
        path="trip-cost-calculator"
        element={
          <>
            <SectionBackButton to="/car" label="Back to Car" />
            <TripCostCalculator />
          </>
        }
      />
      <Route
        path="contacts"
        element={
          <>
            <SectionBackButton to="/car" label="Back to Car" />
            <CarContactsSection />
          </>
        }
      />
      <Route
        path="*"
        element={
          <div className="min-h-screen bg-theme-secondary pb-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="py-8">
                <h1 className="text-3xl font-bold text-theme-primary mb-2">
                  Car Management
                </h1>
                <p className="text-theme-secondary mb-8">
                  Track fuel consumption, maintenance, and expenses
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {/* Service Book Card */}
                  <div
                    className="bg-theme-primary rounded-lg shadow-sm border border-theme-primary p-6 cursor-pointer hover:shadow-md transition-shadow group"
                    onClick={() => navigate('/car/service-book')}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <Book className="h-8 w-8 text-theme-primary group-hover:text-primary-600 transition-colors" />
                    </div>
                    <h3 className="text-lg font-semibold text-theme-primary mb-2">
                      Service Book
                    </h3>
                    <p className="text-theme-secondary text-sm">
                      All your car service records in one place
                    </p>
                  </div>

                  {/* Fuel Tracking Card */}
                  <div
                    className="bg-theme-primary rounded-lg shadow-sm border border-theme-primary p-6 cursor-pointer hover:shadow-md transition-shadow group"
                    onClick={() => navigate('/car/fuel')}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <Fuel className="h-8 w-8 text-theme-primary group-hover:text-primary-600 transition-colors" />
                    </div>
                    <h3 className="text-lg font-semibold text-theme-primary mb-2">
                      Fuel Tracking
                    </h3>
                    <p className="text-theme-secondary text-sm">
                      Track fuel consumption and costs
                    </p>
                  </div>

                  {/* Car Gallery Card */}
                  <div
                    className="bg-theme-primary rounded-lg shadow-sm border border-theme-primary p-6 cursor-pointer hover:shadow-md transition-shadow group"
                    onClick={() => navigate('/car/gallery')}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <GalleryHorizontal className="h-8 w-8 text-theme-primary group-hover:text-primary-600 transition-colors" />
                    </div>
                    <h3 className="text-lg font-semibold text-theme-primary mb-2">
                      Car Gallery
                    </h3>
                    <p className="text-theme-secondary text-sm">
                      Your car photo gallery
                    </p>
                  </div>

                  {/* Trip Cost Calculator Card */}
                  <div
                    className="bg-theme-primary rounded-lg shadow-sm border border-theme-primary p-6 cursor-pointer hover:shadow-md transition-shadow group"
                    onClick={() => navigate('/car/trip-cost-calculator')}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <Calculator className="h-8 w-8 text-theme-primary group-hover:text-blue-600 transition-colors" />
                    </div>
                    <h3 className="text-lg font-semibold text-theme-primary mb-2">
                      Trip Cost Calculator
                    </h3>
                    <p className="text-theme-secondary text-sm">
                      Calculate your trip fuel cost and split by people
                    </p>
                  </div>

                  {/* Car Contacts Card */}
                  <div
                    className="bg-theme-primary rounded-lg shadow-sm border border-theme-primary p-6 cursor-pointer hover:shadow-md transition-shadow group"
                    onClick={() => navigate('/car/contacts')}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <Phone className="h-8 w-8 text-theme-primary group-hover:text-primary-600 transition-colors" />
                    </div>
                    <h3 className="text-lg font-semibold text-theme-primary mb-2">
                      Car Contacts
                    </h3>
                    <p className="text-theme-secondary text-sm">
                      Keep workshop and car-business contact details in one place
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      />
    </Routes>
  );
};

export default CarSection; 